<template lang="pug">
.bg-grey.w-full.p-40
  div
    BriqPanel(v-if="mainBooker")
      .header.mb-S
        h2.h2 Customer
        .actions
          BriqButton.mr-XXXS(
            small
            v-if="businessAllowsChangeCustomer"
            variant="secondary"
            :disabled="disableEditCustomer"
            @click="openSelectOtherCustomerDialog"
            data-test-id="select-other-customer"
            ) Select other customer
          BriqButton(
            small
            v-if="businessAllowsEditCustomer"
            variant="secondary"
            :disabled="disableEditCustomer"
            @click="goToEditCustomerPage"
            data-test-id="edit-customer"
            ) Edit customer
      BriqTable.mb-S(data-test-id="booking-customer-table")
        tr
          td.bold Name
          td {{ mainBooker.FullName }}
        tr
          td.bold Phone
          td {{ mainBooker.Mobilenumber }}
        tr
          td.bold E-mail
          td {{ mainBooker.Email }}
        // tr
          td.bold Role
          td todo: mainBooker.RoleName
        // tr
          td.bold Birthday
          td {{ mainBooker.Birthdate }}
        template(v-show="hasCompany")
          tr
            td.bold Company name
            td {{ mainBooker.CompanyName }}
          tr
            td.bold Company address
            td {{ mainBooker.CompanyAddress }}
          tr
            td.bold ZIP
            td {{ mainBooker.CompanyZipcode }}
          tr
            td.bold City
            td {{ mainBooker.CompanyCity }}
      // BriqButton(small) Add financial contact -- will be added later, remember to use v-if with feature BookingAddCustomer
    h2(v-else) Booking has no main booker
  SelectOtherCustomerDialog(v-if="showSelectOtherCustomerDialog" :customerKey="mainBooker.Key" @close="showSelectOtherCustomerDialog = false")
</template>

<script>
import { mapGetters } from 'vuex'
import SelectOtherCustomerDialog from './SelectOtherCustomerDialog.vue'
import BusinessFeature from '@/vue/models/BusinessFeatureEnum.js'
import Permission from '@v/models/UserPermissionEnum.js'

export default {
  name: 'CustomerTab',
  components: { SelectOtherCustomerDialog },
  data() {
    return {
      showSelectOtherCustomerDialog: false,
    }
  },
  computed: {
    ...mapGetters('bookingDetails', ['customers', 'mainBooker', 'booking']),
    ...mapGetters('briqState', ['businessUnitHasFeature', 'userHasPermission']),
    disableEditCustomer() {
      return !this.userHasPermission(Permission.API_Admin_Booking_Customer_Create)
    },
    hasCompany() {
      return !!this.mainBooker.CompanyName
    },
    businessAllowsChangeCustomer() {
      return this.businessUnitHasFeature(BusinessFeature.BookingChangeCustomer)
    },
    businessAllowsEditCustomer() {
      return this.businessUnitHasFeature(BusinessFeature.CustomerEdit)
    },
  },
  methods: {
    goToEditCustomerPage() {
      const url = `customers/${this.mainBooker.Key}/edit?booking=${this.booking.Key}&role=${this.mainBooker.Role}`
      this.$setLocationPath(url)
    },
    openSelectOtherCustomerDialog() {
      this.showSelectOtherCustomerDialog = true
    },
  },
  beforeMount() {
    this.$setDocumentTitle(`Booking ${this.booking.Number} customers`)
  },
}
</script>

<style lang="stylus" scoped>
.max-w-718
  max-width 718px

.header
  display flex
  justify-content space-between
</style>
